import { useState, useEffect } from 'preact/hooks';
import { HexColorPicker } from "powerful-color-picker";
import { addMarker, findMarkers, updateMarker } from '../api/api';
import Form from '../components/ui/Form';
import SubmitButton from '../components/ui/SubmitButton';
import {useToaster} from '../context/ToasterContext';
import useApp from '../context/AppContext';

export default function MarkersList() {
    const { markers, setMarkers } = useApp();
    const [markersCopy, setMarkersCopy] = useState(null);
    const [color, setColor] = useState("#aabbcc");
    const [currentMarker, setCurrentMarker] = useState(null);
    const addToast = useToaster();

    function selectColor(event, marker) {
        const _color = marker ? marker.color : "#ccc";
        setCurrentMarker({ marker, elt: event.target });
        setColor(_color);
    }

    function changeColor(_color) {
        if (typeof currentMarker != 'undefined' && currentMarker) {
            currentMarker.elt.style = "background-color: " + _color;
            currentMarker.elt.value = _color;
            currentMarker.elt.parentNode.childNodes[0].value = _color;
            if (currentMarker.marker) currentMarker.marker.color = _color;
        }
    }

    function handleSubmit(e) {
        e.preventDefault();
        e.returnValue = '';
        let promiseAll = [];
        const fields = e.target;
        // Parcourir les lignes
        // Tester si la case est cochée
        // - Si oui, faire un appel api pour supprimer le marqueur
        markers.map((marker) => {
            if (fields['color_' + marker.id].value != marker.color) {
                promiseAll.push(
                    updateMarker({ color: fields['color_' + marker.id].value }, marker.id)
                );
            }
        });
        if (fields.newMarkerName && fields.newMarkerName.value != '') {
            promiseAll.push(addMarker({ name: fields.newMarkerName.value, color: fields.newMarkerColor.value }));
        }

        Promise.all(promiseAll)
            .then((responses) => {
                try {
                    let errors = 0;
                    responses.map(response => {
                        if (!response) errors++;
                    });
                    if (errors == 0) {
                        addToast('success', responses.length + ' changement(s) effectué(s)');
                        findMarkers().then((_markers) => {
                            if (!_markers.message) {
                                setMarkers(_markers);
                                setMarkersCopy(_markers);
                            }
                        });
                        fields.newMarkerName.value = "";
                        fields.newMarkerColor.value = "";
                    }
                    else addToast('info', 'Aucun changement détecté');
                }
                catch (err) {
                    console.log(err);
                }
            })
            .catch((err) => {
                console.log(err);
                addToast('danger', 'Impossible d\'enregistrer les marqueurs, erreur réseau');
            });
    }

    if (typeof markers == 'undefined' || markers === null) {
        return <div className="text-center pt-5">Loading markers ...</div>;
    }

    useEffect(() => {
        if (!markersCopy) {
            setMarkersCopy(JSON.parse(JSON.stringify(markers)));
        }
    }, []);

    if (typeof markersCopy == 'undefined' || markersCopy === null) {
        return <div className="text-center pt-5">Loading markers ...</div>;
    }

    return (
        <div class="container-md mt-2">
            <h1 class="text-center">Gestion des marqueurs</h1>
            <Form onSubmit={(handleSubmit)}>
                {
                    markersCopy.map((marker) => {
                        return (
                            <div key={marker.id} class="row align-items-start">
                                {/* <span class="col-1 mb-2">
                                    <input type="checkbox" class="form-check-input" id={'chk' + marker.id} name={'chk' + marker.id} value={marker.id} />
                                </span> */}
                                <label class="col" for={'chk' + marker.id}>{marker.name} ({marker.animals.length})</label>
                                <span class="col">
                                    <input type="hidden" id={'color_' + marker.id} name={'color_' + marker.id} value={marker.color} />
                                    <div id={marker.id} class="marker-shape big" style={{ backgroundColor: marker.color }} value={marker.color} onClick={(e) => { selectColor(e, marker) }} />
                                </span>
                            </div>
                        )
                    })
                }
                <div class="row align-items-start mb-3">
                    {/* <span class="col-1">&nbsp;</span> */}
                    <span class="col">
                        <input type="text" class="col" id="newMarkerName" name="newMarkerName" placeholder="Nouveau marqueur" size="8" />
                    </span>
                    <span class="col">
                        <input type="hidden" id="newMarkerColor" name="newMarkerColor" value={color} />
                        <div id="newMarker" class="marker-shape big" style={{ backgroundColor: color }} onClick={(e) => { selectColor(e) }} />
                    </span>
                </div>
                <HexColorPicker class="mt-3" color={color} onChange={changeColor} />
                <SubmitButton />
            </Form>
        </div>
    );
}